import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { Score } from '../db/score.js';
import {
  getScoresByExamDayAndCandidatesResolver,
  subscribeScoresByExamDayAndCandidatesResolver,
} from '../server/resolver/scores.js';

export const getScoresByExamDayAndCandidates = registerQuery({
  operationName: 'getScoresByExamDayAndCandidates',
  resolve: getScoresByExamDayAndCandidatesResolver,
  type: () => [Score],
  params: [
    { name: 'candidateIDs', type: () => [String] },
    { name: 'examDayID', type: () => String },
  ],
});

export const subscribeScoresByExamDayAndCandidates = registerSubscription({
  operationName: 'subscribeScoresByExamDayAndCandidates',
  resolve: subscribeScoresByExamDayAndCandidatesResolver,
  type: () => [Score],
  params: [
    { name: 'candidateIDs', type: () => [String] },
    { name: 'examDayID', type: () => String },
  ],
});
